import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

export interface Props {
    currentValue?: number,
    previousValue?: number,
    percentage: boolean,
    title: string;
    previousTitle: string;
    unit?: string;
    suffix?: string;
    titleTooltip?: string;
    onClick?: () => void;
}

const colorGreen = 'rgb(var(--color-success))';
const colorRed = 'rgb(var(--color-danger))';

const GrowthStatistic = (props: Props) => {
    const titleElement = props.titleTooltip ? (
        <Tooltip title={props.titleTooltip}><span>{props.title}</span></Tooltip>
    ) : <span>{props.title}</span>;

    const hasValue = props.currentValue !== undefined && props.currentValue !== null;

    const previousTooltip = props.previousTitle
        ? props.previousTitle + ': ' + (props.previousValue ? (props.unit || '') : '') + (props.previousValue ? Math.round(props.previousValue).toLocaleString() : 'N/A')
        : undefined;

    if (!hasValue) {
        return (
            <div className="min-w-[100px]">
                <div className="text-2xs text-text-3 uppercase tracking-wider font-medium mb-1 leading-tight">{titleElement}</div>
                <div className="text-base text-text-3 font-mono tabular-nums">
                    {previousTooltip ? <Tooltip title={previousTooltip}><span>—</span></Tooltip> : '—'}
                </div>
            </div>
        );
    }

    const currentValue = props.currentValue!;
    const canCalculateGrowth = props.previousValue != null && props.previousValue >= 1 && currentValue >= 1;

    let growthDisplay = '';
    let color = '';
    let prefix: React.ReactNode = null;

    if (canCalculateGrowth) {
        const growth = ((currentValue - props.previousValue!) / props.previousValue!) * 100.0;

        if (growth > 100) {
            const multiplier = currentValue / props.previousValue!;
            growthDisplay = multiplier.toFixed(1) + 'x';
            color = colorGreen;
            prefix = <ArrowUpOutlined />;
        } else if (growth > 0) {
            growthDisplay = growth.toFixed(2) + (props.percentage ? '%' : '');
            color = colorGreen;
            prefix = <ArrowUpOutlined />;
        } else if (growth < 0) {
            growthDisplay = growth.toFixed(2) + (props.percentage ? '%' : '');
            color = colorRed;
            prefix = <ArrowDownOutlined />;
        }
    } else if (props.previousValue != null) {
        growthDisplay = '-';
    }

    const isClickable = props.onClick && hasValue;
    const valueFormatted = (props.unit || '') + Math.round(currentValue).toLocaleString() + (props.suffix || '');

    const valueNode = (
        <span className={`text-md font-semibold font-mono tabular-nums leading-none ${isClickable ? 'text-accent' : 'text-text'}`}>
            {valueFormatted}
        </span>
    );

    return (
        <div onClick={props.onClick} className={`min-w-[100px] ${isClickable ? 'cursor-pointer' : ''}`}>
            <div className="text-2xs text-text-3 uppercase tracking-wider font-medium mb-1 leading-tight">{titleElement}</div>
            <div>
                {previousTooltip ? <Tooltip title={previousTooltip}>{valueNode}</Tooltip> : valueNode}
            </div>
            {growthDisplay && (
                <div className="text-xs mt-0.5 font-mono tabular-nums" style={{ color }}>
                    {prefix} {growthDisplay}
                </div>
            )}
        </div>
    );
};
export default GrowthStatistic;
